import React from "react"

import { AppFormDrawer } from "@components"
import { isAlertsDrawerOpen, alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"


export default function AlertsBaseDrawer({ footer, content }) {
	const { idAlert, conditionName } = alertsDrawerData.peek()

	return <AppFormDrawer
		icon="cowbell"
		title={idAlert ? 'Edit condition' : 'Create a new Alert'}
		subtitle={idAlert ? `${alertsSection.value} · ${conditionName}` : alertsSection.value}
		width="40%"
		variant="persistent"
		isOpen={isAlertsDrawerOpen.value}
		controller={() => alertsDrawerData.value = {}}
		footer={footer}
	>
		{content}
	</AppFormDrawer>
}
